module.exports = __webpack_public_path__ + "Open_Sans-normal-300.0d0d7107450f05b72a45.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Open_Sans-normal-300.woff
// module id = 900
// module chunks = 2